module.exports = __webpack_public_path__ + "img/selected1-min.f134475e.png";